import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';
import { logErrorAndRunFail } from '../../utils';

export interface GetStorageOption extends Partial<GeneralInvokeOption> {
  key: string;
  encrypt?: boolean;
}

// 从本地缓存中获取指定key的内容
export function getStorage(option: GetStorageOption) {
  if (!option?.key) {
    return logErrorAndRunFail(
      APINames.Native.GET_STORAGE,
      option,
      'parameter error:parameters.key should be String instead of Undefined.'
    );
  }
  const fixedOption = Object.assign({ encrypt: false }, option);
  return MacleJSBridge.beforeInvoke(APINames.Native.GET_STORAGE, fixedOption);
}
